import React from 'react'
import { Table } from 'react-bootstrap';

var ClientStore = require('../../stores/ClientStore');
var Invocation = require('../../api/Invocation');
var OutdatedRow = require('./OutdatedRow');

var Outdated = React.createClass({
  componentDidMount() {
    ClientStore.addChangeListener(this.update);

    this.update()
  },

  componentWillUnmount: function () {
    ClientStore.removeChangeListener(this.update);
  },

  getInitialState() {
    return {
      client: null,
      data: null,
    }
  },

  update() {
    const client = ClientStore.get()

    if (client && this.state.client !== client.id) {
      Invocation.clientService.outdated(client.id)
        .then(res => this.setState({
          data: res.body.services
        }))

      this.setState({
        client: client.id,
      })
    }
  },

  render: function () {
    if (!this.state.data || !this.state.data.length) {
      return <div />
    }

    return (
      <section className="powerwidget orange">
        <header><h2>New service options available</h2></header>
        <div className="inner-spacer">
          <div className="callout callout-info">
            <p>
              Great news! We have new plans available for some of your services
              that might provide better value for you.
            </p>
          </div>
          <div className="table-responsive">
            <Table className="table-striped table-hover">
              <thead>
                <tr>
                  <th>Service</th>
                  <th>Current Plan</th>
                  <th />
                </tr>
              </thead>
              <tbody>
                {this.state.data.map(option => (
                  <OutdatedRow serviceId={option.id} key={option.id} />
                ))}
              </tbody>
            </Table>
          </div>
        </div>
      </section>
    );
  },
})
module.exports = Outdated;



// WEBPACK FOOTER //
// ./app/components/ClientService/Outdated.js